import React, { useState } from 'react';
import { Colors } from 'library';
import { Grid, PillButton, Row, Stack, Text, TextInput, Title } from 'library/ui';
import { Place, Search, CheckCircleOutline, AccessTime, StarOutline } from '@mui/icons-material';
import { StaffFilterOptions, defaultFilters } from 'parent-portal/shared/filterOptions';

export function HomeFindSection({
    zipCode,
    updateZipCode,
    onSearch,
}: {
    zipCode: string;
    updateZipCode: (value: string) => void;
    onSearch: (filters: StaffFilterOptions) => void;
}) {
    const [showHelperText, setShowHelperText] = useState(false);

    function search() {
        if (zipCode.length < 5) {
            setShowHelperText(true);
        } else {
            setShowHelperText(false);
            onSearch(defaultFilters);
        }
    }

    return (
        <Stack gap="lg">
            <Title size="h1">Find Staff</Title>
            <Text size="sm" tone="secondary">
                Enter your zip code to see available substitutes nearby.
            </Text>
            <TextInput
                value={zipCode}
                onChange={updateZipCode}
                onSubmit={search}
                placeholder="Zip Code"
                color="white"
                fullWidth
                error={showHelperText ? 'Please enter a valid zip code' : undefined}
                startAdornment={<Place style={{ color: Colors.primary }} />}
            />
            <PillButton onClick={search} icon={<Search style={{ fontSize: 20 }} />}>
                Search Available Staff
            </PillButton>
            <Grid columns={2} gap="sm">
                <TrustBadge
                    icon={<CheckCircleOutline style={trustIconStyle} />}
                    text="Background checked & compliant"
                />
                <TrustBadge
                    icon={<CheckCircleOutline style={trustIconStyle} />}
                    text="State-licensed credentials verified"
                />
                <TrustBadge icon={<AccessTime style={trustIconStyle} />} text="Available for same-day coverage" />
                <TrustBadge icon={<StarOutline style={trustIconStyle} />} text="Rated by centers like yours" />
            </Grid>
        </Stack>
    );
}

function TrustBadge({ icon, text }: { icon: React.ReactNode; text: string }) {
    return (
        <Row gap="sm">
            {icon}
            <Text size="xs" tone="secondary">
                {text}
            </Text>
        </Row>
    );
}

const trustIconStyle = { fontSize: 18, color: Colors.secondary };
